import { useEffect } from 'react';

import { ExpirationOptionId } from '../types';

/**
 * Custom hook for managing form submit button state
 * Handles DOM manipulation for form validation based on passkey and date requirements
 */
export const useFormValidation = (
  contextType: string,
  passkey: string,
  showingNewPasskeyField: boolean,
  isGuestPasskeySectionEnabled: boolean,
  expirationOption: ExpirationOptionId,
  customDate: string
): void => {
  /**
   * Manages form submit button state based on validation rules
   * Disables submit if required fields are missing
   */

  useEffect(() => {
    const updateButtonState = (): void => {
      const submitButton: HTMLInputElement = document.querySelector(
        `.j-submit-${contextType}-privacy-settings input[type='submit']`
      );

      if (submitButton) {

        // Only check for empty customDate when custom_date option is actually selected
        const isCustomDateEmptyAndSelected =
          expirationOption === 'custom_date' && !customDate;

        // Check if passkey is required but missing
        const isPasskeyMissing = isGuestPasskeySectionEnabled && !passkey && showingNewPasskeyField;

        // Disable if passkey is missing OR custom date is selected but empty
        if (isPasskeyMissing || isCustomDateEmptyAndSelected) {
          submitButton.disabled = true;
          submitButton.classList.add('disabled');
        } else {
          submitButton.disabled = false;
          submitButton.classList.remove('disabled');
        }
      }
    };

    updateButtonState();
  }, [passkey, isGuestPasskeySectionEnabled, expirationOption, customDate, contextType, showingNewPasskeyField]);
};
